import { Box } from '@chakra-ui/react'

type Props = {
  viewerUrl: string
}

export const DICOMViewer: React.FC<Props> = ({ viewerUrl }) => {
  return (
    <Box w="full" h="full">
      <iframe width="100%" height="100%" src={viewerUrl} />
    </Box>
  )
}
